// extracted by mini-css-extract-plugin
export var quillEditor = "_kf-1";
export var variable = "_kf-0";